import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import { withRouter } from "react-router-dom";

import { config } from '../Constants';
import moment from 'moment';
import helpers from '../Function';
import ReactExport from 'react-data-export';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery"
import Multiselect from 'react-widgets/lib/Multiselect'

import LoadingOverlay from 'react-loading-overlay';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ReportPresale extends Component {

    constructor(props) {
        super(props);

        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        const style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }
            , fill: { patternType: "solid", fgColor: { rgb: "E8EFF5" } }
        }

        this.state = {
            PROJECTID: project_id,
            user_permission: user_permission,
            pages: [{ number: ' ' }],
            dataReport: [],
            project_home: [],
            service_category: [],
            juristic_type: [],
            DataSetCategory: [{}],
            DataSetTracking: [{}],
            DataSetProject: [{}],
            jwt: jwt,
            src_project: [],
            src_user_type: '',
            src_channel: '',
            src_startdate: '',
            src_enddate: '',
            src_member: '',
            src_phonein: '',
            page: 0,
            rowsPerPage: 10,
            report_type: 'tracking',
            isActiveLoading: false,
            colTracking: [],
            rowsTracking: [],
            colProject: [],
            rowsProject: [],
            report_title: 'Tracking Report (รายงานแสดงรายละเอียดแยกตามผู้ใช้งาน)',
        }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.dataTable = this.dataTable.bind(this);
        this.change = this.change.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.openView = this.openView.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.clearData = this.clearData.bind(this);
        this.changeReport = this.changeReport.bind(this);

        this.project_home()
        this.dataTable()
    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    project_home() {
        var body = ``
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.PROJECTID) {
            body = `?projecthomeid=${this.state.PROJECTID}`
            fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        } else {
            fetch(config.url.API_URL + '/project_homes/', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        }

    }

    async dataTable() {
        this.setState({
            dataReport: await this.dataReportTracking()
        })
    }

    changeStartDate = date => {
        this.setState({
            src_startdate: date
        });
    }

    changeEndDate = date => {
        this.setState({
            src_enddate: date
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });

    }

    handleSubmit(e) {
        e.preventDefault();
    }

    async openView() {
        //report_type
        this.setState({
            pages: [{ number: ' ' }],
            page: 0,
            rowsPerPage: 10,
            isActiveLoading: true
        });

        if (this.state.report_type == "tracking") {
            this.setState({
                dataReport: await this.dataReportTracking()
            })
        } else if (this.state.report_type == "project") {
            this.setState({
                dataReport: await this.dataReportProject(this.state.project_home)
            })

        }
        /*
        console.log("*****************%%%%%%%*********************")
        console.log(JSON.stringify(this.state.dataReport))
        console.log("*****************%%%%%%%*********************")
        */
        this.setState({
            isActiveLoading: false
        });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    clearData(e) {
        this.setState({
            src_project: [],
            src_user_type: '',
            src_channel: '',
            src_startdate: '',
            src_enddate: '',
            src_member: '',
            src_phonein: '',
            pages: [{ number: '' }],
            dataReport: [],
            colTracking: [],
            rowsTracking: [],
            colProject: [],
            rowsProject: [],
        });
        document.getElementById("form-submit").reset();
    }

    async dataReportTracking() {

        var startdate = (this.state.src_startdate ? this.state.src_startdate : '');
        var enddate = (this.state.src_enddate ? this.state.src_enddate : '');
        console.log("startdate",startdate)
        console.log("enddate",enddate)
        var net = 0
        var style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }
            , fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
        }

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };
        var projecttmp = ""
        for (var i = 0; i < this.state.src_project.length; i++) {
            if (i == 0) {
                projecttmp += this.state.src_project[i].value
            } else {
                projecttmp += "," + this.state.src_project[i].value
            }
        }

        await fetch(config.url.API_URL + '/presale_trackings?projecthomeid=' + projecttmp
            + '&membername=' + this.state.src_member
            + '&typeuser=' + this.state.src_user_type
            + '&phone=' + this.state.src_phonein
            + '&startdate=' + startdate
            + '&enddate=' + enddate, requestOptions)
            .then(res => res.json())
            .then(data => {
                var DataFrom = data.data

                var FromExcel = DataFrom.map((datas, i) => {
                    net += 1
                    return [
                        { value: (i + 1), style },
                        { value: (datas.member_name === undefined ? '' : datas.member_name + ''), style },
                        { value: datas.project_name + '', style },
                        { value: helpers.getMemberType(datas.type_user) + '', style },
                        { value: (datas.telephone === undefined ? '' : datas.telephone + ''), style },
                        { value: (datas.device_type === undefined ? '' : datas.device_type + ''), style },
                        { value: moment(datas.created).format('DD/MM/YYYY H:mm น.') + '', style },
                        { value: (datas.device_model === undefined ? '' : datas.device_model + ''), style },
                    ]
                });

                style = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "12", bold: true }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }

                var col_title = [{ title: "Tracking Report (รายงานแสดงรายละเอียดแยกตามผู้ใช้งาน)", width: { wpx: 300 }, style }]

                style = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "10" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }

                var col_date = [{ title: "วันที่ : " + (startdate == '' ? 'ทั้งหมด' : moment(startdate).format('DD/MM/YYYY')) + " - " + (enddate == '' ? 'ทั้งหมด' : moment(enddate).format('DD/MM/YYYY')), width: { wpx: 300 }, style }]

                var col_net = [{
                    title: "รวมทั้งหมด " + net + " รายการ", width: { wpx: 300 }, style: {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }
                            , left: { style: "thin", color: { rgb: "000000" } }
                            , right: { style: "thin", color: { rgb: "000000" } }
                            , bottom: { style: "thin", color: { rgb: "000000" } }
                        }
                        , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                        , alignment: { horizontal: "right" }
                        , fill: {
                            patternType: "solid"
                            , fgColor: { rgb: "EEEEEE" }
                        }
                    }
                }]

                style = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "E8EFF5" }
                    }
                }

                var col = [
                    { title: "No.", width: { wpx: 60 }, style },
                    { title: "ผู้ใช้งาน", width: { wpx: 150 }, style },
                    { title: "โครงการ", width: { wpx: 300 }, style },
                    { title: "ประเภทผู้ใช้งาน", width: { wpx: 150 }, style },
                    { title: "เบอร์โทร", width: { wpx: 120 }, style },
                    { title: "OS", width: { wpx: 80 }, style },
                    { title: "วันเวลา", width: { wpx: 120 }, style },
                    { title: "Device Model", width: { wpx: 150 }, style },
                ]

                this.setState({
                    pages: [].concat(DataFrom),
                    DataSetTracking: [
                        {
                            columns: col_title
                            , data: []
                        },
                        {
                            columns: col_date
                            , data: []
                        },
                        {
                            columns: col_net
                            , data: []
                        },
                        {
                            columns: col
                            , data: [].concat(FromExcel)
                        }
                    ],
                    colTracking: col,
                    rowsTracking: [].concat(FromExcel)
                });
            });

        return this.state.DataSetTracking;
    }

    async dataReportProject(proj) {
        var project = []
        var net = 0
        var dataNet = []

        var startdate = (this.state.src_startdate ? this.state.src_startdate : '');
        var enddate = (this.state.src_enddate ? this.state.src_enddate : '');
        var status = [
            { value: "owner" }
            , { value: "guest" }
            , { value: "live" }
            , { value: "install" }
            , { value: "normal" }
            , { value: "social" }
            , { value: "renter" }
        ]

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };
        var style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
        }

        for (var i = 0; i < proj.length; i++) {
            console.log(proj[i].value)
            if (proj[i].value) {
                var value = []
                var total = 0;
                await fetch(config.url.API_URL + '/reportprojectpresale/?project_home_id=' + proj[i].value
                    + '&startdate=' + startdate
                    + '&enddate=' + enddate, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        var datas = data.data

                        for (var j = 0; j < status.length; j++) {

                            const result = datas.find(({ _id }) => _id === status[j].value);
                            var resultCount = 0
                            if (result === undefined) {
                                value.push({ value: 0, style })
                            } else {
                                resultCount = result.count
                                total += result.count
                                value.push({ value: result.count, style })
                            }
                            if (dataNet[j] === undefined) {
                                dataNet.push(resultCount)
                            } else {
                                dataNet[j] = (parseInt(dataNet[j]) + resultCount)
                            }
                        }
                        net += total
                    });

                //console.log("*****************API reportstatus*********************"+JSON.stringify(value))
                value.unshift({ value: total, style })
                value.unshift({
                    value: proj[i].display, style: {
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } }
                            , left: { style: "thin", color: { rgb: "000000" } }
                            , right: { style: "thin", color: { rgb: "000000" } }
                            , bottom: { style: "thin", color: { rgb: "000000" } }
                        }
                        , font: { name: "Tahoma", sz: "10" }, fill: { patternType: "solid", fgColor: { rgb: "FFFFFF" } }
                    }
                })
                project = project.concat([value])
            }
        }

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }, alignment: { horizontal: "center" }
            , fill: { patternType: "solid", fgColor: { rgb: "E8EFF5" } }
        }

        var col = [
            { title: "ชื่อโครงการ", width: { wpx: 300 }, style },
            { title: "รวมทั้งหมด", width: { wpx: 100 }, style },
            { title: "เจ้าของบ้าน", width: { wpx: 150 }, style },
            { title: "ชมโครงการ", width: { wpx: 150 }, style },
            { title: "ผู้อยู่อาศัย", width: { wpx: 150 }, style },
            { title: "ผ่อนดาวน์", width: { wpx: 150 }, style },
            { title: "สมาชิกระบบ", width: { wpx: 150 }, style },
            { title: "สมาชิกจากโซเซียล", width: { wpx: 150 }, style },
            { title: "ผู้เช่า", width: { wpx: 150 }, style }
        ]
        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "12", bold: true }
            , fill: {
                patternType: "solid"
                , fgColor: { rgb: "FFFFFF" }
            }
        }

        var col_title = [{ title: "Project Summary Report (รายงานสรุปจำนวนใบงานแยกตามสถานะ)", width: { wpx: 300 }, style }]

        style = {
            border: {
                top: { style: "thin", color: { rgb: "000000" } }
                , left: { style: "thin", color: { rgb: "000000" } }
                , right: { style: "thin", color: { rgb: "000000" } }
                , bottom: { style: "thin", color: { rgb: "000000" } }
            }
            , font: { name: "Tahoma", sz: "10" }
            , fill: {
                patternType: "solid"
                , fgColor: { rgb: "FFFFFF" }
            }
        }

        var col_date = [{ title: "วันที่ : " + moment(startdate).format('DD/MM/YYYY') + " - " + moment(enddate).format('DD/MM/YYYY'), width: { wpx: 300 }, style }]

        var col_net = [{
            value: "รวมทั้งหมด ", style: {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                , alignment: { horizontal: "right" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }
        }, {
            value: net, style: {
                border: {
                    top: { style: "thin", color: { rgb: "000000" } }
                    , left: { style: "thin", color: { rgb: "000000" } }
                    , right: { style: "thin", color: { rgb: "000000" } }
                    , bottom: { style: "thin", color: { rgb: "000000" } }
                }
                , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                , alignment: { horizontal: "center" }
                , fill: {
                    patternType: "solid"
                    , fgColor: { rgb: "FFFFFF" }
                }
            }
        }]

        for (var i = 0; i < dataNet.length; i++) {
            col_net.push({
                value: dataNet[i], style: {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } }
                        , left: { style: "thin", color: { rgb: "000000" } }
                        , right: { style: "thin", color: { rgb: "000000" } }
                        , bottom: { style: "thin", color: { rgb: "000000" } }
                    }
                    , font: { name: "Tahoma", sz: "12", color: "4796C8" }
                    , alignment: { horizontal: "center" }
                    , fill: {
                        patternType: "solid"
                        , fgColor: { rgb: "FFFFFF" }
                    }
                }
            })
        }

        project.unshift(col_net)

        this.setState({
            DataSetProject: [{
                columns: col_title
                , data: []
            }, {
                columns: col_date
                , data: []
            },
            {
                columns: col
                , data: project
            }],
            colProject: col,
            rowsProject: project
        });

        return this.state.DataSetProject;

    }

    changeReport(event) {
        //event.target.value
        this.setState({
            [event.target.name]: event.target.value
        });

        if (event.target.value == "tracking") {
            this.setState({
                report_title: 'Tracking Report (รายงานแสดงรายละเอียดแยกตามผู้ใช้งาน)'
            })
            $('#src_project').prop("disabled", false);
            $('#src_channel').prop("disabled", false);
            $('#src_user_type').prop("disabled", false);
            $('#src_phonein').prop("disabled", false);
            $('#src_member').prop("disabled", false);
        } else if (event.target.value == "project") {
            this.setState({
                report_title: 'Project Summary Report (รายงานสรุปจำนวนใบงานแยกตามโครงการ)'
            })
            $('#src_project').prop("disabled", true);
            $('#src_channel').prop("disabled", true);
            $('#src_user_type').prop("disabled", true);
            $('#src_phonein').prop("disabled", true);
            $('#src_member').prop("disabled", true);
        }
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
                padding: 3,
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 6,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <LoadingOverlay active={this.state.isActiveLoading} spinner text='Loading...' >
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Report Presale/ รายงานพรีเซลล์</h1>
                                </div>{/* /.col */}
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                                        <li className="breadcrumb-item active">report</li>
                                    </ol>
                                </div>{/* /.col */}
                            </div>{/* /.row */}
                        </div>{/* /.container-fluid */}
                    </div>
                    {/* /.content-header */}
                    {/* Main content */}
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <form id="form-submit" onSubmit={this.handleSubmit}>
                                            <div className="row mt-3 mb-3">
                                                <div className="col-sm-1">
                                                    <img src={"../dist/img/icon/ic_report_head.png"} className="header-icon" />
                                                </div>
                                                <div className="col-sm-11">
                                                    <div className="row">
                                                        <div className="col-sm-2 text-right">โครงการ</div>
                                                        <div className="col-sm-6">
                                                            {/* <select className="form-control" id="src_project" name="src_project" style={{ height: 45, display: 'none' }} onChange={this.change}>
                                                                {
                                                                    this.state.project_home.map((datas) =>
                                                                        <option value={datas.value}>{datas.display}</option>)
                                                                }
                                                            </select> */}
                                                            <Multiselect
                                                                data={this.state.project_home}
                                                                valueField='value'
                                                                textField='display'
                                                                value={this.state.src_project}
                                                                onChange={src_project => this.setState({ src_project: src_project })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">ชื่อผู้ใช้</div>
                                                        <div className="col-sm-2">
                                                            <input type="text" className="form-control" id="src_member" name="src_member" onChange={this.change} />
                                                        </div>
                                                        <div className="col-sm-1 text-right">ประเภท</div>
                                                        <div className="col-sm-3">
                                                            <select className="form-control" id="src_user_type" name="src_user_type" style={{ height: 45 }} onChange={this.change}>
                                                                <option value="0">เลือกสถานะ</option>
                                                                <option value="owner">เจ้าของบ้านโอนกรรมสิทธิ์แล้ว</option>
                                                                <option value="guest">บุคคลทั่วไป</option>
                                                                <option value="live">ผู้อาศัย</option>
                                                                <option value="install">เจ้าของบ้านรอโอนกรรมสิทธิ์</option>
                                                                <option value="normal">สมาชิกระบบทั่วไป</option>
                                                                <option value="social">สมาชิกจากโซเชียล</option>
                                                                <option value="renter">ผู้เช่า</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">วันที่</div>
                                                        <div className="col-sm-2">
                                                            <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.src_startdate} id="src_startdate" name="src_startdate" className="form-control" onChange={this.changeStartDate} dateFormat="dd/MM/yyyy" />
                                                        </div>
                                                        <div className="col-sm-1 text-right">ถึง</div>
                                                        <div className="col-sm-3">
                                                            <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.src_enddate} id="src_enddate" name="src_enddate" className="form-control" onChange={this.changeEndDate} dateFormat="dd/MM/yyyy" />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">

                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">เบอร์โทรเข้า</div>
                                                        <div className="col-sm-2">
                                                            <input type="text" className="form-control" id="src_phonein" name="src_phonein" onChange={this.change} />
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-2 text-right">ประเภทรายงาน</div>
                                                        <div className="col-sm-5">
                                                            <select className="form-control" id="report_type" name="report_type" style={{ height: 45 }} onChange={this.changeReport}>
                                                                <option value="tracking">รายงานสรุปความสนใจแยกตามผู้ใช้งาน</option>
                                                                <option value="project">รายงานสรุปความสนใจแยกตามโครงการ</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mt-3">
                                                        <div className="col-sm-12 text-right">
                                                            <button className="btn-advance" style={{ height: 45, float: "none" }} onClick={this.openView}>ค้นหารายการ</button>
                                                            <ExcelFile filename={(
                                                                this.state.report_type == "tracking" && 'Tracking Case Summary Report-' + moment().format('DDMMYYYY')
                                                                ||
                                                                this.state.report_type == "project" && 'Project Summary by Status Report-' + moment().format('DDMMYYYY')
                                                            )} element={(this.state.user_permission[64].permission == 1 &&
                                                                <button className="btn-advance" style={{ height: 45, float: "none" }}><img src={"../dist/img/icon/ic_print.png"} className="menu-icon" /> ดาวน์โหลด</button>
                                                            )}>
                                                                <ExcelSheet dataSet={this.state.dataReport} name="Organization" />
                                                            </ExcelFile>
                                                            <button className="btn-advance" style={{ height: 45, float: "none" }} onClick={this.clearData}>เคลียร์</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {/* .card-header */}
                                    <div className="card-body" style={{ overflowX: 'auto' }}>
                                        <h4>{this.state.report_title}</h4>
                                        {(
                                            this.state.report_type == "tracking" &&
                                            (<Table className="report-preview">
                                                <thead>
                                                    {
                                                        this.state.colTracking.map(data => {
                                                            //console.log(data.title)
                                                            return (<th>{data.title}</th>)
                                                        })
                                                    }
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rowsTracking.map(data => {
                                                            //console.log(data.title)
                                                            return (<tr>
                                                                {
                                                                    data.map(items => {
                                                                        return (<td style={
                                                                            {
                                                                                color: "#" + (items.style.font.color === undefined ? "" : items.style.font.color)
                                                                            }}>{items.value}</td>)
                                                                    })
                                                                }
                                                            </tr>)
                                                        })
                                                    }
                                                </tbody>
                                            </Table>) ||
                                            this.state.report_type == "project" &&
                                            (<Table className="report-preview">
                                                <thead>
                                                    <tr>
                                                        {
                                                            this.state.colProject.map((data, key) => {
                                                                //console.log(data.title)
                                                                return (<th style={{ width: (key == 0 && 300 || key == 1) }}>{data.title}</th>)
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.rowsProject.map((data, key) => {
                                                            //console.log(data.title)
                                                            return (<tr>
                                                                {
                                                                    data.map(items => {
                                                                        //check style ตรงนี้
                                                                        return (<td style={
                                                                            {
                                                                                backgroundColor: "#" + items.style.fill.fgColor.rgb
                                                                                , color: "#" + (items.style.font.color === undefined ? "" : items.style.font.color)
                                                                            }}>
                                                                            {items.value}
                                                                        </td>)
                                                                    })
                                                                }
                                                            </tr>)
                                                        })
                                                    }
                                                </tbody>
                                            </Table>)
                                        )
                                        }
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </section>
                    {/* /.content */}
                </LoadingOverlay>
            </div>
        )
    }
}

export default withRouter(ReportPresale);